var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChevronLeft = function SvgChevronLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 18.9999C14.2338 19.0004 14.4603 18.919 14.6402 18.7699C14.7415 18.686 14.8252 18.5829 14.8865 18.4665C14.9479 18.3502 14.9857 18.2229 14.9977 18.0919C15.0098 17.9609 14.9959 17.8289 14.9569 17.7033C14.9178 17.5777 14.8544 17.461 14.7702 17.3599L10.2902 11.9999L14.6102 6.62994C14.6933 6.52765 14.7553 6.40996 14.7927 6.28362C14.8302 6.15728 14.8422 6.02479 14.8283 5.89376C14.8144 5.76273 14.7747 5.63575 14.7115 5.52011C14.6483 5.40447 14.5629 5.30246 14.4602 5.21994C14.3567 5.1289 14.2356 5.06024 14.1043 5.01825C13.973 4.97626 13.8345 4.96185 13.6974 4.97594C13.5603 4.99002 13.4276 5.03229 13.3076 5.1001C13.1877 5.1679 13.083 5.25977 13.0002 5.36994L8.17019 11.3699C8.02311 11.5489 7.94271 11.7733 7.94271 12.0049C7.94271 12.2366 8.02311 12.461 8.17019 12.6399L13.1702 18.6399C13.2705 18.761 13.3979 18.8566 13.5422 18.9192C13.6864 18.9817 13.8433 19.0094 14.0002 18.9999Z",
    fill: "#3F4857"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChevronLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevron_left.9fde188f.svg";
export { ForwardRef as ReactComponent };